function CTLDialogContent(theme, ownerState) {
    const { palette } = theme;
    const { white, background } = palette;
    const { darkMode } = ownerState;

    return {
        backgroundColor: darkMode ? background.card : white.main,
        padding: "12px 16px",
    }
}

function CTLDialogPaper(theme, ownerState) {
    const { palette } = theme;
    const { white, background } = palette;
    const { darkMode } = ownerState;

    return {
        backgroundColor: darkMode ? background.card : white.main,
        borderRadius: "8px",
        boxShadow: darkMode
            ? "0 8px 24px rgba(0, 0, 0, 0.4)"
            : "0 8px 24px rgba(0, 0, 0, 0.12)",
        overflow: "hidden",
    }
}

export  default CTLDialogContent
export { CTLDialogPaper }
